import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

const ModalDropDown = ({
    label,
    name,
    value,
    options,
    handleDropDownChange,
    width,
    className=''
}) => {
  return (
    <FormControl 
        //sx={{width:`${width}px`,mb:2}} 
        sx={{mb:2}} 
        margin="dense"
        className={className}
        fullWidth
    >
        <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel>
        <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            sx={{ "&:focus": {
                backgroundColor: "#ffffff"
                } 
            }}
            label={label} 
            value={value}
            onChange={handleDropDownChange}
            name={name}
        >
            <MenuItem value="">{label}</MenuItem>
            { options?.map((option) => (
                <MenuItem data-value={option.data_value} key={option.value} value={option.value}>{option.name}</MenuItem>
            ))}
        </Select>
    </FormControl>
  )
}

export default ModalDropDown